import React from "react";

import {
  Button,
  DatePicker,
  ButtonToolbar,
  Form,
  Input,
  InputPicker,
  Table,
  Pagination,
  Modal,
  Popover,
  Whisper,
  Divider,
  Checkbox,
} from "rsuite";
import { invoiceModel } from "../../../formsValidation";
import { useEffect, createContext, useState } from "react";

import { ActionsIcon } from "../../Settings/Components/Locations/Locations";
import { default as InvoicesHeader } from "./Components/InvoicesHeader/InvoicesHeader";
import styles from "./Invoices.module.css";
import { useInvoices } from "./useInvoices";
import PageContainer from "../../../Components/PageContainer/PageContainer";
import AttachedFiles from "./Components/AttachedFiles/AttachedFiles";
//import ActionLogs from './Components/ActionLogs/ActionLogs';
// import { Document, Page, pdfjs } from 'react-pdf';
// import 'react-pdf/dist/esm/Page/TextLayer.css';
import PdfPreview from "./Components/PdfPreview/PdfPreview";
import MainForm from "./Components/MainForm/MainForm";
import ArowBackIcon from "@rsuite/icons/ArowBack";
import FileDownloadIcon from "@rsuite/icons/FileDownload";
import ConfirmationModal from "../../../Components/ConfirmationModal/ConfirmationModal";
import { useConfirmationModal } from "../../../Components/ConfirmationModal/useConfirmationModal";
import DocumentTitle from "../../../Components/DocumentTitle";
import { useInvoicesHeader } from "./Components/InvoicesHeader/useInvoicesHeader";
import ActionLogs from "./../../../Components/ActionLogs/ActionLogs";
import moment from "moment";

import {
  getAccessLevel,
  getResponsibleName,
  isAttachedInvoicesBlockAvaliable,
} from "../../../helperFunctions";

const { Column, HeaderCell, Cell } = Table;

//export const InvoicesContext = createContext();
function Invoices() {
  DocumentTitle("RitePMS Office - Invoices");

  let {
    tableLoading,
    invoices,
    setActivePage,
    activePage,
    itemsPerPage,
    invoicesArrayLength,
    section,
    formHandler,
    form,
    formMode,
    showCreateInvoice,
    showEditInvoice,
    createInvoice,
    updateInvoice,

    getInvoices,
    cancel,
    countFormChanges,
    resetFormChanges,

    ispdfShow,
    selectedPdf,
    numPages,
    pageNumber,
    handlepdfShow,
    sortColumn,
    handleSort,
    handleCheckBox,
  } = useInvoices();

  let { filter } = useInvoicesHeader();

  const accessLevel = getAccessLevel();

  const responsibleName = getResponsibleName();
  const isCheckboxAvailable = ["Admin", "Accountant"].includes(responsibleName)
    ? true
    : false;
  const { showConfirmationModal } = useConfirmationModal();

  if (form?.document_type == undefined) form.document_type = "Invoice";

  useEffect(() => {
    getInvoices();
  }, [activePage]); //, form

  let ActionsCell = ({ rowData, dataKey, ...props }) => {
    const handleClick = (event) => {
      event.stopPropagation(); // Prevent row click
      event.preventDefault(); // Prevent any default behavior
    };
    const isChecked = !!rowData.invoice_posted_date;
    return (
      <>
        <Cell {...props}>
          <div id="posted-checkbox" className={styles.actions_cell_container}>
            {rowData["status"] != "deleted" && (
              <span style={{ paddingLeft: "15px" }}>
                <ActionsIcon
                  type="edit"
                  onEdit={(event) => {
                    //showEditInvoice(rowData["_id"]);
                  }}
                />
              </span>
            )}

            {isCheckboxAvailable && (
              <PostedCheckBox
                checked={isChecked}
                onClick={(event) => {
                  handleCheckBox(rowData["_id"], rowData["number"]);
                }}
                invoice_posted_date={rowData["invoice_posted_date"]}
              />
            )}
          </div>
        </Cell>
      </>
    );
  };

  let InvoiceIDCell = ({ rowData, dataKey, ...props }) => {
    const tooltip = <Popover>Added at: {rowData["createdAt"]}</Popover>;

    return (
      <Cell style={{ height: "30px", padding: "15px 5px 15px 0px" }} {...props}>
        <Whisper
          placement="right"
          controlId="control-id-hover"
          trigger="hover"
          speaker={tooltip}
        >
          <div style={{ fontSize: "13px", paddingLeft: 12 }}>
            {rowData["invoice_id"]}
          </div>
        </Whisper>

        {/* <div style={{ fontSize: '14px' }} key={rowData['invoice_id']}>
					  {rowData['invoice_id']}
					</div> */}
      </Cell>
    );
  };

  let InvoiceDateCell = ({ rowData, dataKey, ...props }) => {
    let tooltip;
    let tooltipDue;
    let dueDate = "";
    let invoceDate = "";
    const document_type = rowData["document_type"]
      ? rowData["document_type"]
      : "";

    const noDueDate =
      !rowData["invoice_due_date"] || rowData["invoice_due_date"] == ""
        ? "(Due date not set)"
        : "";
    const invoiceDateText = `Invoice date ${noDueDate}`;
    if (rowData["invoice_date"] && rowData["invoice_date"] != "") {
      tooltip = <Popover>{invoiceDateText}</Popover>;
      invoceDate = moment
        .utc(rowData["invoice_date"], moment.ISO_8601)
        .format("DD/MM/YYYY");
    }

    if (rowData["invoice_due_date"] || rowData["invoice_due_date"] == "") {
      tooltipDue = <Popover>Due date</Popover>;
      dueDate = moment
        .utc(rowData["invoice_due_date"], moment.ISO_8601)
        .format("DD/MM/YYYY");
    }
    const tipInvoiceNumber = <Popover>Invoice Number</Popover>;
    return (
      <Cell
        style={{ height: "150px", padding: "15px 5px 15px 0px" }}
        {...props}
      >
        <div className={styles.cell_container}>
          {document_type != "Invoice" && (
            <div style={{ fontSize: "13px", width: "150px" }}>
              {document_type}
            </div>
          )}
          <Whisper
            placement="top"
            controlId="control-id-invoce-date"
            trigger="hover"
            speaker={tipInvoiceNumber}
          >
            <div
              style={{ fontSize: "14px", paddingBottom: 8, fontWeight: 600 }}
              key={rowData["invoice_number"]}
            >
              {rowData["invoice_number"]}
            </div>
          </Whisper>

          <Whisper
            placement="top"
            controlId="control-id-invoce-date"
            trigger="hover"
            speaker={tooltip}
          >
            <div style={{ fontSize: "13px", width: "150px" }}>{invoceDate}</div>
          </Whisper>

          <Whisper
            placement="top"
            controlId="control-id-hover"
            trigger="hover"
            speaker={tooltipDue}
          >
            <div style={{ fontSize: "13px", width: "150px" }}>{dueDate}</div>
          </Whisper>
        </div>
      </Cell>
    );
  };

  let DepartmentCell = ({ rowData, dataKey, ...props }) => {
    return (
      <Cell
        style={{ height: "150px", padding: "15px 5px 15px 0px" }}
        {...props}
      >
        <div className={styles.cell_container}>
          <div style={{ fontSize: "13px" }} key={rowData["department"]}>
            {rowData["department"]}
          </div>
          <div style={{ fontSize: "13px" }} key={rowData["type"]}>
            {rowData["type"]}
          </div>
        </div>
      </Cell>
    );
  };

  let FromCompanyCell = ({ rowData, dataKey, ...props }) => {
    return (
      <Cell
        style={{ height: "165px", padding: "15px 5px 15px 0px" }}
        {...props}
      >
        <div style={{ fontSize: "13px" }} key={rowData["invoice_from"]}>
          {rowData["invoice_from"]}
        </div>
      </Cell>
    );
  };
  let ToCompanyCell = ({ rowData, dataKey, ...props }) => {
    return (
      <Cell
        style={{ height: "165px", padding: "15px 5px 15px 0px" }}
        {...props}
      >
        <div style={{ fontSize: "13px" }} key={rowData["invoice_to"]}>
          {rowData["invoice_to"]}
        </div>
      </Cell>
    );
  };
  let VesselCell = ({ rowData, dataKey, ...props }) => {
    const tooltip = <Popover>Purchase order</Popover>;
    return (
      <Cell
        style={{ height: "155px", padding: "15px 5px 15px 0px" }}
        {...props}
      >
        <div className={styles.cell_container}>
          <div style={{ fontSize: "13px" }} key={rowData["vessel_name"]}>
            {rowData["vessel_name"] == "none" ? "" : rowData["vessel_name"]}
          </div>
          <Whisper
            delay={500}
            placement="top"
            controlId="control-id-hover"
            trigger="hover"
            speaker={tooltip}
          >
            <div
              style={{ fontSize: "12px" }}
              key={rowData["purchase_order_number"]}
            >
              {rowData["purchase_order_number"]
                ? rowData["purchase_order_number"]
                : ""}
            </div>
          </Whisper>
        </div>
      </Cell>
    );
  };
  let AmountCell = ({ rowData, dataKey, ...props }) => {
    const tooltip = rowData["invoice_order_amount"] ? (
      <Popover>Order amount: {rowData["invoice_order_amount"]}</Popover>
    ) : (
      <Popover>Invoice total</Popover>
    );
    const fileToolTip = <Popover>{rowData["invoice_filename"]}</Popover>;

    const handleDownloadPdf = (e, pdfUrl) => {
      e.stopPropagation();

      if (pdfUrl) {
        // window.open(pdfUrl, '_blank');
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    };

    return (
      <Cell
        style={{ height: "150px", padding: "15px 5px 13px 0px" }}
        {...props}
      >
        <div className={styles.cell_container}>
          <Whisper
            placement="top"
            controlId="control-id-hover"
            trigger="hover"
            speaker={tooltip}
          >
            <span
              style={{ fontSize: "13px" }}
            >{`${rowData["invoice_total"]} ${rowData["invoice_currency"]}`}</span>
          </Whisper>
        </div>
        {rowData["invoice_filename"].length > 4 && (
          <div style={{ marginLeft: 10 }}>
            <Whisper
              delay={500}
              placement="top"
              controlId="control-id-hover"
              trigger="hover"
              speaker={fileToolTip}
            >
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handlepdfShow(rowData["invoice_filename"]);
                }}
                //onClick={() => handlepdfShow(rowData['invoice_filename'])}
                style={{
                  background: "none",
                  border: "none",
                  color: "blue",
                  fontSize: "12px",
                  cursor: "pointer",
                }}
              >
                View PDF
              </button>
            </Whisper>
            <span className={styles.actions_download_icon}>
              <FileDownloadIcon
                onClick={(e) =>
                  handleDownloadPdf(e, rowData["invoice_filename"])
                }
                style={{
                  fontSize: "11px",
                  marginRight: 10,
                  cursor: "pointer",
                  marginTop: "0px",
                }}
              />
            </span>
          </div>
        )}
      </Cell>
    );
  };

  let UserName = ({ rowData, dataKey, ...props }) => {
    return (
      <Cell style={{ padding: "15px 5px 15px 0px" }} {...props}>
        <div style={{ fontSize: "13px" }} key={rowData["user_name"]}>
          {rowData["user_name"]}
        </div>
      </Cell>
    );
  };

  // QC column — Admin only, shown only when the user has filtered status='OCR'
  // (server-side QC runs on creation, so only OCR-status rows have meaningful
  // values; everything else would show an unhelpful '—').
  const isAdminViewer = responsibleName === "Admin";
  const showQCColumn = isAdminViewer && filter?.status === "OCR";

  let QCCell = ({ rowData, ...props }) => {
    const result = rowData?.qcResult;
    const message = rowData?.qcMessage || "QC not run yet";

    const color =
      result === "pass" ? "#16a34a" : result === "failed" ? "#dc2626" : "#9ca3af";
    const label = result === "pass" ? "pass" : result === "failed" ? "failed" : "—";

    const tooltip = <Popover style={{ maxWidth: 480 }}>{message}</Popover>;

    return (
      <Cell style={{ padding: "15px 5px 15px 0px" }} {...props}>
        <Whisper
          delay={300}
          placement="left"
          controlId="control-id-qc"
          trigger="hover"
          speaker={tooltip}
        >
          <span
            style={{
              display: "inline-block",
              padding: "2px 8px",
              borderRadius: 10,
              fontSize: 11,
              fontWeight: 600,
              color: "#fff",
              background: color,
              cursor: "default",
            }}
          >
            {label}
          </span>
        </Whisper>
      </Cell>
    );
  };

  let getActionDate = (rowData, actionName) => {
    if (rowData?.actions) {
      const foundAction = rowData.actions.find(
        (action) => action.invoiceStatus === actionName
      );
      if (!foundAction) return "";
      const regex = /(\d{2}\/\d{2}\/\d{4})/; // Match DD/MM/YYYY anywhere
      const match = foundAction.time.match(regex);
      if (match && match[0]) {
        return match[0];
      } else {
        console.error("Date pattern not found in the string.");
        return "";
      }
    } else return "";
  };

  let InvoiceStatus = ({ rowData, dataKey, ...props }) => {
    let invoice_approved_date = "";
    if (rowData?.invoice_approved_date) {
      invoice_approved_date = moment
        .utc(rowData?.invoice_approved_date, moment.ISO_8601)
        .format("DD/MM/YYYY");
    }
    let invoice_posted_date = "";
    if (rowData["invoice_posted_date"]) {
      invoice_posted_date = moment
        .utc(rowData["invoice_posted_date"], moment.ISO_8601)
        .format("DD/MM/YYYY");
    }
    let invoice_paid_date = "";
    if (rowData?.invoice_status == "Paid") {
      if (rowData?.invoice_paid_date) {
        invoice_paid_date = moment
          .utc(rowData?.invoice_paid_date, moment.ISO_8601)
          .format("DD/MM/YYYY");
      } else {
        invoice_paid_date = getActionDate(rowData, "Paid");
      }
    }

    return (
      <Cell style={{ padding: "15px 5px 15px 0px" }} {...props}>
        <div
          style={{ fontSize: "13px", height: 50 }}
          key={rowData["invoice_status"]}
        >
          {rowData["invoice_status"]}
          {rowData["invoice_status"] == "Approved" && (
            <div style={{ fontSize: "12px" }} key={invoice_approved_date}>
              {invoice_approved_date}
            </div>
          )}
          {rowData["invoice_status"] == "Paid" && (
            <div style={{ fontSize: "12px" }} key={invoice_paid_date}>
              {invoice_paid_date}
            </div>
          )}
        </div>

        {invoice_posted_date && (
          <div
            style={{ fontSize: "10px", paddingTop: "7px" }}
            key={invoice_posted_date}
          >
            Posted {invoice_posted_date}
          </div>
        )}
      </Cell>
    );
  };

  let getRawStyle = (rowData) => {
    if (rowData?.invoice_status == "Paid") return "paid";
    if (!rowData?.invoice_due_date) return "";
    if (["Cancelled", "Rejected", "Deleted"].includes(rowData?.invoice_status))
      return "";

    let style = "";

    const dateNow = moment().utc().startOf("day").format();
    const dateIn7Days = moment(dateNow)
      .add(7, "day")
      .utc()
      .startOf("day")
      .format();
    const invoiceDueDate = moment(rowData?.invoice_due_date)
      .utc()
      .startOf("day")
      .format();

    //if (invoiceDueDate <= dateIn7Days) style = "dueIn7Days";
    if (invoiceDueDate < dateNow) style = "overDue";

    return style;
  };

  let allInvoices_section = (
    <>
      <InvoicesHeader />
      <div className={styles.table_container}>
        <Table
          sortColumn={sortColumn}
          onSortColumn={handleSort}
          wordWrap="break-word"
          height={800}
          rowHeight={100}
          data={invoices}
          loading={tableLoading}
          autoHeight={true}
          rowClassName={getRawStyle}
          onRowClick={(rowData) => {
            showEditInvoice(rowData["_id"]);
          }}
        >
          <Column sortable width={70} resizable>
            <HeaderCell style={{ height: "30px" }}>
              <span>ID</span>
            </HeaderCell>

            <InvoiceIDCell dataKey="createdAt" />
          </Column>

          <Column width={165} resizable>
            <HeaderCell>Bill To</HeaderCell>
            <ToCompanyCell dataKey="invoice_to" />
          </Column>

          <Column width={165} resizable>
            <HeaderCell>Vendor</HeaderCell>
            <FromCompanyCell dataKey="invoice_from" />
          </Column>

          <Column width={125} resizable>
            <HeaderCell>Vessel/PO</HeaderCell>
            <VesselCell dataKey="vessel_name" />
          </Column>

          <Column sortable width={145} resizable>
            <HeaderCell>Invoice</HeaderCell>
            <InvoiceDateCell dataKey="invoice_date" />
          </Column>

          <Column width={130} resizable>
            <HeaderCell>Amount</HeaderCell>
            <AmountCell dataKey="invoice_total" />
          </Column>

          <Column width={140} resizable>
            <HeaderCell>Dep./Type</HeaderCell>
            <DepartmentCell dataKey="type" />
          </Column>

          <Column width={120} resizable>
            <HeaderCell>User</HeaderCell>
            <UserName dataKey="user_name" />
          </Column>

          <Column sortable width={95} resizable>
            <HeaderCell>Status</HeaderCell>
            <InvoiceStatus dataKey="invoice_status" />
          </Column>

          {showQCColumn && (
            <Column width={80} resizable>
              <HeaderCell>QC</HeaderCell>
              <QCCell dataKey="qcResult" />
            </Column>
          )}

          <Column width={75}>
            <HeaderCell>Actions</HeaderCell>
            <ActionsCell dataKey="_id" />
          </Column>
        </Table>

        <div className={styles.pagination_container}>
          <Pagination
            prev
            next
            first
            last
            ellipsis
            size="xs"
            layout={["total", "-", "pager"]}
            total={invoicesArrayLength}
            limit={itemsPerPage}
            maxButtons={10}
            activePage={activePage}
            onChangePage={setActivePage}
          />
        </div>
      </div>

      {selectedPdf && (
        <PdfPreview ispdfShow={ispdfShow} selectedPdf={selectedPdf} />
      )}
    </>
  );

  const itemReadonly = false; //isItemReadonly(accessLevel, form.status);

  const showAttachedInvoicesBlock = isAttachedInvoicesBlockAvaliable(
    accessLevel,
    form.status
  );

  let inputsStatus = "readonly";
  if (
    [
      "OCR",
      "OCR Complete",
      "New",
      "Assigned",
      "Rejected",
      "Not Invoice",
    ].includes(form.invoice_status)
  ) {
    inputsStatus = "can_edit";
  }

  let form_section = (
    <>
      <div className={styles.invoices_header}>
        <div className={styles.invoices_header_title}>
          <div
            className={styles.arrow_back_btn}
            onClick={() => {
              ConfirmationModalNew(
                cancel,
                countFormChanges,
                showConfirmationModal,
                resetFormChanges
              );
            }}
          >
            <ArowBackIcon className={styles.arrow_back} />
          </div>{" "}
          {formMode == "create" ? (
            "Add Invoice  "
          ) : (
            <>
              {" "}
              Edit {form?.document_type} | [No. {form?.invoice_id}]{" "}
              {form.invoice_number} {<span>({form.invoice_status})</span>}
            </>
          )}
        </div>

        <div className={styles.invoices_header_files}>
          <AttachedFiles readonly={inputsStatus == "readonly" ? true : false} />
        </div>
      </div>

      <div className={styles.form_container}>
        <MainForm
          formMode={formMode}
          readonly={inputsStatus == "readonly" ? true : false}
          invoiceModel={invoiceModel}
          formHandler={formHandler}
          form={form}
          topButton={
            <>
              <FormButtons
                readonly={inputsStatus == "readonly" ? true : false}
                formMode={formMode}
                status={form?.invoice_status}
                countFormChanges={countFormChanges}
                cancel={() => {
                  ConfirmationModalNew(
                    cancel,
                    countFormChanges,
                    showConfirmationModal,
                    resetFormChanges
                  );
                }}
              />
            </>
          }
        />

        {
          <div style={{ marginTop: "20px", gap: "30px" }}>
            <FormButtons
              readonly={inputsStatus == "readonly" ? true : false}
              formMode={formMode}
              status={form?.invoice_status}
              countFormChanges={countFormChanges}
              position="bottom"
              cancel={() => {
                ConfirmationModalNew(
                  cancel,
                  countFormChanges,
                  showConfirmationModal,
                  resetFormChanges
                );
              }}
            />
          </div>
        }

        {form?.actions?.length && <ActionLogs actions={form.actions} />}
      </div>

      {/* {formMode == 'edit' && (
	    <DeleteItemBlock item='purchaseOrder' onDelete={deletePurchaseOrder} />
	  )} */}
    </>
  );

  return (
    <>
      <PageContainer>
        {section == "all Invoices" && allInvoices_section}
        {section == "form" && form_section}
      </PageContainer>

      <ConfirmationModal />
    </>
  );
}

export default Invoices;

const Textarea = React.forwardRef((props, ref) => (
  <Input {...props} as="textarea" ref={ref} />
));

const ConfirmationModalNew = (
  onClose,
  countFormChanges,
  showConfirmationModal,
  resetFormChanges
) => {
  if (countFormChanges > 2) {
    showConfirmationModal("cancelexit", onClose);
  } else {
    resetFormChanges();
    onClose();
  }
};

const FormButtons = ({
  readonly,
  formMode,
  status,
  countFormChanges,
  cancel,
  position,
}) => {
  console.log(countFormChanges);
  let { createInvoice, updateInvoice, updateStatus, deleteInvoice } =
    useInvoices();
  const accessLevel = getAccessLevel();
  const responsibleName = getResponsibleName();
  const isReadyToBePaidEnabled = ["Admin"].includes(responsibleName)
    ? true
    : false;
  const isPaidEnabled = ["Admin", "Accountant"].includes(responsibleName)
    ? true
    : false;
  const isApprovedisabled = countFormChanges > 1 ? true : false;
  const { showConfirmationModal } = useConfirmationModal();

  const createAndUpdateButton = (
    <Button
      onClick={formMode == "create" ? createInvoice : updateInvoice}
      appearance="primary"
      style={{ width: "150px", marginRight: "20px" }}
    >
      Save
    </Button>
  );

  const cancelInvoiceButton = (
    <>
      <Button
        onClick={() => {
          showConfirmationModal("cancelInvoice", () => {
            updateStatus("Canceled");
          });
        }}
        color="red"
        appearance="ghost"
        style={{ width: "150px" }}
      >
        Cancel invoice
      </Button>
    </>
  );
  const toolOcrComplete = (
    <Popover>
      Set the status to "New" (OCR has been completed) so the invoice can be
      reviewed and approved.
    </Popover>
  );
  const setOCRComplete = (
    <Whisper
      delay={500}
      placement="topStart"
      controlId="control-id-hover"
      trigger="hover"
      speaker={toolOcrComplete}
    >
      <Button
        onClick={() => {
          updateStatus("New");
        }}
        appearance="primary"
        color="violet"
        style={{ width: "150px", marginRight: "20px" }}
      >
        Complete OCR
      </Button>
    </Whisper>
  );

  const toolApprove = isApprovedisabled ? (
    <Popover>Save the form before approving</Popover>
  ) : (
    <Popover>
      Approve the invoice and set the status to "Ready for Payment". The invoice
      will no longer be editable.
    </Popover>
  );

  const approveButton = (
    <Whisper
      delay={500}
      placement="topStart"
      controlId="control-id-hover"
      trigger="hover"
      speaker={toolApprove}
    >
      <Button
        disabled={isApprovedisabled}
        onClick={() => {
          showConfirmationModal("approveInvoice", () => {
            updateStatus("Approved");
          });
        }}
        appearance="primary"
        color="green"
        style={{ width: "150px", marginRight: "20px" }}
      >
        Approve
      </Button>
    </Whisper>
  );

  const tootForPayment = (
    <Popover>
      Assign the bank name and update the invoice status to 'Ready to be Paid'
    </Popover>
  );
  const forPaymentButton = (
    <Whisper
      delay={500}
      placement="topStart"
      controlId="control-id-hover"
      trigger="hover"
      speaker={tootForPayment}
    >
      <Button
        disabled={!isReadyToBePaidEnabled}
        onClick={() => {
          updateStatus("For payment");
        }}
        appearance="primary"
        color="green"
        style={{ width: "160px", marginRight: "20px" }}
      >
        Set Ready to be Paid
      </Button>
    </Whisper>
  );

  const toolpaid = <Popover>Set the invoice status to 'Paid'</Popover>;
  const paidButton = (
    <Whisper
      delay={500}
      placement="topStart"
      controlId="control-id-hover"
      trigger="hover"
      speaker={tootForPayment}
    >
      <Button
        disabled={!isPaidEnabled}
        onClick={() => {
          updateStatus("Paid");
        }}
        appearance="primary"
        color="green"
        style={{ width: "160px", marginRight: "20px" }}
      >
        Set as Paid
      </Button>
    </Whisper>
  );

  const closeButton = (
    <Button onClick={cancel} appearance="default" style={{ width: "150px" }}>
      Close
    </Button>
  );

  const deleteButton = (
    <Button
      disabled={!isPaidEnabled}
      onClick={() => {
        showConfirmationModal("deleteInvoice", () => {
          deleteInvoice();
        });
      }}
      appearance="primary"
      color="red"
      style={{ width: "150px", marginLeft: "25px" }}
    >
      Delete Invoice
    </Button>
  );
  // if (accessLevel < 1) {
  //   return <>{closeButton}</>;
  // }
  if (accessLevel >= 1 && accessLevel < 3) {
    return (
      <>
        {" "}
        {createAndUpdateButton} {closeButton}{" "}
      </>
    );
  }

  if (accessLevel >= 3) {
    if (status == "OCR")
      if (position == "bottom")
        return (
          <>
            {createAndUpdateButton} {setOCRComplete} {closeButton}{" "}
            <div style={{ paddingTop: 20 }}>
              {cancelInvoiceButton}

              {accessLevel == 5 && deleteButton}
            </div>
          </>
        );
      else
        return (
          <>
            {createAndUpdateButton} {setOCRComplete} {closeButton}{" "}
          </>
        );

    if (status == "New" || status == "OCR")
      if (position == "bottom")
        return (
          <>
            {createAndUpdateButton} {approveButton} {closeButton}{" "}
            <div style={{ paddingTop: 20 }}>
              {cancelInvoiceButton}

              {accessLevel == 5 && deleteButton}
            </div>
          </>
        );
      else
        return (
          <>
            {createAndUpdateButton} {approveButton} {closeButton}{" "}
          </>
        );

    if (status == "Approved")
      return (
        <>
          {forPaymentButton} {closeButton}
        </>
      );
    if (status == "For payment")
      return (
        <>
          {paidButton} {closeButton}
        </>
      );
  }

  if (accessLevel == 5) {
    if (status == "Duplicate" && position == "bottom")
      return (
        <>
          {closeButton} {deleteButton}{" "}
        </>
      );
  }
  return <>{closeButton}</>;
};

export function PostedCheckBox({ checked, onClick, invoice_posted_date }) {
  let isDisabled = false;
  let date = null;
  if (invoice_posted_date) {
    checked = true;
    isDisabled = true;
    let date = new Date(invoice_posted_date);
  }

  return (
    <>
      {" "}
      <span style={{ fontSize: 9, paddingLeft: "10px" }}>Posted</span>
      <Checkbox
        disabled={isDisabled}
        checked={checked}
        onClick={(event) => {
          event.stopPropagation(); // Prevent event bubbling
          if (isDisabled) return;
          onClick(event); // Call the provided onClick handler
        }}
        onChange={() => {}}
        style={{ paddingLeft: "7px" }}
      />
    </>
  );
}
